import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { submitMusicApi, getMusicByIdApi } from "../../services/MeditationBackgroundMusic";

function CreateMusic() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [audioFile, setAudioFile] = useState(null);
  const [audioPreview, setAudioPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      (async () => {
        const res = await getMusicByIdApi(id);
        if (res?.data) {
          setValue("meditation_background_music_category", res.data.meditation_background_music_category);
          setAudioPreview(res.data.audioUrl);
        }
      })();
    }
  }, [id, setValue]);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const payload = {
        ...data,
        audioFile,
      };
      if (id) payload._id = id;
      const res = await submitMusicApi(payload);
      if (res) {
        navigate("/background-music-list");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleAudioChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAudioFile(file);
      setAudioPreview(URL.createObjectURL(file));
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Edit Background Music" : "Add Background Music"}
        navigation="Background Music"
        navlink="/background-music-list"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-8 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Music" : "Add New Music"}</h2>
            </div>

            <div className="col-md-12">
              <label className="form-label">Meditation Background Music Category</label>
              <input
                className="form-control"
                {...register("meditation_background_music_category", { required: "Meditation Background Music Name is required" })}
              />
              {errors.meditation_background_music_category && <p className="text-danger">{errors.meditation_background_music_category.message}</p>}
            </div>

            <div className="col-md-12">
              <label className="form-label">Audio File</label>
              <input
                type="file"
                className="form-control"
                accept="audio/*"
                onChange={handleAudioChange}
              />
              {audioPreview && (
                <div className="mt-3">
                  <p>Preview:</p>
                  <audio controls src={audioPreview} style={{ width: "100%" }} preload="none">
                    Your browser does not support the audio element.
                  </audio>
                </div>
              )}
            </div>

            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5 me-3" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span className="visually-hidden">Loading...</span> Please wait...
                  </>
                ) : (
                  id ? "Update" : "Save"
                )}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/background-music-list")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateMusic;
